'use strict';
(function () {
  angular.module('pentaApp').factory('payWithPoints.modal', factory);
  factory.$inject = ['bottomModal.factory'];
  function factory(bottomModal) {
    return bottomModal.create({
      controller: controller,
      templateUrl: 'modals/payWithPoints/payWithPoints.modal.jade'
    })
  }

  controller.$inject = ['$scope', 'modal', 'data', 'clubPayWithPoints.resource', 'posTable.resource', 'receipt.resource'];
  function controller($scope, modal, modalData, clubPayWithPointsResource, posTableResource, receiptResource) {
    /// METHODS
    $scope.close = close;
    $scope.redeem = redeem;
    $scope.getReceipt = getReceipt;
    $scope.getTables = getTables;
    $scope.modalData = modalData;

    //// VARS
    $scope.routers = $scope.$root.routers.filter(function(f){return f.hasPosIntegration});
    $scope.data = {
      router: $scope.routers.find(function(f){return f._id === $scope.$root.defaultRouter}) || $scope.routers[0],
      posTable: null,
      amount: 0
    }

    /// WATCHERS

    /// INIT
    init()

    ///////////////////////
    function init(){
      getTables()
    }


    function getTables(){
      if(!$scope.data.router) return;
      $scope.receipt = null;
      posTableResource.query({router: $scope.data.router._id}, function(tables){
        $scope.tables = tables.filter(function(f){return f.externalId})
      });
    }

    function getReceipt(){
      if(!$scope.data.posTable || !$scope.data.posTable.externalId) return;
      $scope.receipt = null;
      $scope.receiptReady = false;
      receiptResource.get({reference: $scope.data.posTable.externalId, router: $scope.data.router._id}, function(data){
        $scope.receiptReady = true;
        if(data && data.header) $scope.receipt = data;
      })
    }

    function redeem(){
      if(!$scope.data.router || !$scope.data.router._id || !$scope.data.posTable || !$scope.data.posTable._id) throw new PentaError('Datos insuficientes para hacer el canje');
      // Pagar con puntos no depende de la rule porque pueden aplicar muchas rules
      clubPayWithPointsResource.save({
        router: $scope.data.router._id,
        posTable: $scope.data.posTable._id,
        cashAmount: $scope.data.amount
      }, function(){
        ons.notification.alert({title: i18next.t('Éxito'), message: i18next.t('Canje realizado con éxito, ya puede emitir el ticket')})
        if(modalData && modalData.onFinish) modalData.onFinish();
        close()
      })
    }


    function close(){
      modal.close()
    }

  }

})();
